import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
    faClass: string;
}
export const ROUTES: RouteInfo[] = [
    { path: '/zarpes', title: 'Zarpes',  icon: 'card_travel', class: '', faClass: 'fa fa-ship"' },
    { path: '/embarcaciones', title: 'Embarcaciones',  icon: 'directions_boat', class: '', faClass: 'fa fa-search"' },
    { path: '/concesion-list', title: 'Concesiones',  icon: 'share', class: '', faClass: 'fa fa-search"' },
    { path: '/tripulantes-detalle', title: 'Tripulantes Detalle',  icon: 'supervisor_account', class: '', faClass: 'fa fa-users"' },
    { path: '/certificaciones', title: 'Certificaciones',  icon: 'card_membership', class: '', faClass: 'fa fa-lightbulb"' },
    { path: '/descarga-datos', title: 'Descarga datos',  icon: 'cloud_download', class: '', faClass: 'fa fa-lightbulb"' },
    { path: '/usuario-perfil', title: 'Informacion usuario',  icon: 'person', class: '', faClass: 'fa fa-user-friends"' }
]
// Modificar el path para coincidir con el ruteo ( debe ser la misma)
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}
